"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._isSSR = false;
/**
 * Helper to set ssr mode to simulate no window object returned from getWindow helper.
 *
 * @public
 */
function setSSR(isEnabled) {
    exports._isSSR = isEnabled;
}
exports.setSSR = setSSR;
//# sourceMappingURL=setSSR.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib-commonjs/dom/setSSR.js
// module id = 492
// module chunks = 0